
import { Region } from '../types/region-types';

// This file contains general regions in Mexico with their metadata
export const general_mexico_regions: Region[] = [
  {
    region_id: "CHIS",
    english_name: "Chiapas",
    spanish_name: "Chiapas",
    church_presence: "Low",
    pledges: 220000,
    target_need: 220000,
    missionaries: 12,
    languages: ["Spanish", "Maya", "Zapotec", "Totonac"],
    coordinates: [-92.2725, 16.7535],
    church_funding: []
  },
  {
    region_id: "HGO",
    english_name: "Hidalgo",
    spanish_name: "Hidalgo",
    church_presence: "Low",
    pledges: 190000,
    target_need: 190000,
    missionaries: 10,
    languages: ["Spanish", "Nahuatl", "Otomi"],
    coordinates: [-98.7577, 20.4859],
    church_funding: []
  },
  {
    region_id: "CHIH",
    english_name: "Chihuahua",
    spanish_name: "Chihuahua",
    church_presence: "Good",
    pledges: 150000,
    target_need: 200000,
    missionaries: 15,
    languages: ["Spanish"],
    coordinates: [-106.0691, 28.6353],
    church_funding: []
  },
  {
    region_id: "SON",
    english_name: "Sonora",
    spanish_name: "Sonora",
    church_presence: "Good",
    pledges: 125000,
    target_need: 180000,
    missionaries: 14,
    languages: ["Spanish", "Yaqui"],
    coordinates: [-110.9265, 29.2972],
    church_funding: []
  },
  {
    region_id: "DGO",
    english_name: "Durango",
    spanish_name: "Durango",
    church_presence: "Good",
    pledges: 110000,
    target_need: 160000,
    missionaries: 12,
    languages: ["Spanish"],
    coordinates: [-104.6531, 24.0277],
    church_funding: []
  },
  {
    region_id: "COAH",
    english_name: "Coahuila",
    spanish_name: "Coahuila",
    church_presence: "Good",
    pledges: 140000,
    target_need: 170000,
    missionaries: 16,
    languages: ["Spanish"],
    coordinates: [-102.0437, 27.0587],
    church_funding: []
  },
  {
    region_id: "BCN",
    english_name: "Baja California",
    spanish_name: "Baja California",
    church_presence: "Good",
    pledges: 135000,
    target_need: 180000,
    missionaries: 13,
    languages: ["Spanish"],
    coordinates: [-115.1452, 30.8406],
    church_funding: []
  }
];
